const prefix = 'fasr';
const iconName = 'align-center';
const width = 448;
const height = 512;
const aliases = [];
const unicode = 'f037';
const svgPathData = 'M120 40H96V88h24H328h24V40H328 120zM24 168H0v48H24 424h24V168H424 24zM96 296v48h24H328h24V296H328 120 96zM24 424H0v48H24 424h24V424H424 24z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
